export const GET_PASSPORT_REQUEST = "GET_PASSPORT_REQUEST";
export const GET_PASSPORT_SUCCESS = "GET_PASSPORT_SUCCESS";
export const GET_PASSPORT_FAILURE = "GET_PASSPORT_FAILURE";
